/*
 * 101 AUTOTECH - header "Request a Quote" -> BSS RFQ form.
 *
 * The BSS "B2B Order & Request a Quote" app (config-header app embed) appends
 * <bcp-r4q-form-wrapper> to <body> on DOMContentLoaded on every storefront page,
 * and listens on `document` for the custom event `bcpR4q:openForm` (its internal
 * pub/sub: dispatch = document.head.dispatchEvent(new CustomEvent('bcpR4q:openForm',
 * {bubbles:true, composed:true})) ). Firing that event opens the quote form/list -
 * the same action BSS's own "view quote" widget triggers.
 *
 * There is no BSS render entry point for the header/global scope (only product /
 * collection / cart), so we drive the form directly via that event. If BSS has not
 * hydrated yet we wait briefly; if it is genuinely absent on this page (e.g. a
 * stale full-page-cached homepage before the next theme publish) we fall back to
 * the configured RFQ URL so the button is never a dead end.
 */
(function () {
  var OPEN_EVENT = 'bcpR4q:openForm';
  var READY_SELECTOR = 'bcp-r4q-form-wrapper';
  var MAX_WAIT_MS = 2500;
  var POLL_MS = 100;

  function bssReady() {
    return !!document.querySelector(READY_SELECTOR);
  }

  function openForm() {
    document.head.dispatchEvent(
      new CustomEvent(OPEN_EVENT, { bubbles: true, composed: true, detail: {} })
    );
  }

  function activate(button) {
    if (bssReady()) {
      openForm();
      return;
    }
    // BSS embed still initializing - poll for the form wrapper, then open.
    var waited = 0;
    var timer = setInterval(function () {
      waited += POLL_MS;
      if (bssReady()) {
        clearInterval(timer);
        openForm();
      } else if (waited >= MAX_WAIT_MS) {
        clearInterval(timer);
        var fallback = button.getAttribute('data-rfq-fallback');
        if (fallback) {
          window.location.assign(fallback);
        }
      }
    }, POLL_MS);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-rfq-open]');
    if (!button) return;
    event.preventDefault();
    activate(button);
  });
})();
